export default {"src":"/_next/static/media/stars.7203dade.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};